@if(isVisible){
    <div class="sx-system-message__item sxl-flex"
        [ngClass]="{
        'sx-system-message--light-yellow-orange': severity===0 && type==5, 
        'sx-system-message--blue': severity===1 && type!==3 , 
        'sx-system-message--light-blue': severity===1 && type===3 , 
        'sx-system-message--yellow': severity===2 && type!==3, 
        'sx-system-message--light-yellow': severity===2 && type==3, 
        'sx-system-message--red': (severity===3 || severity===4) && type!==3,
        'sx-system-message--light-red': (severity===3 || severity===4) && type===3  
        }">
        @if(icon){
            <div class="sx-system-message__icon-container sxl-flex">
                <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
                    <span class="sx-system-message__icon">
                        <svg>
                            <use [xlink:href]="icon" [attr.href]="icon"/>
                        </svg>
                    </span>
                </div>
            </div>
        }
        <div class="sx-system-message__body sxl-flex sxl-flex-1 sxl-items-center" 
            [ngClass]="{
                'sx-system-message__body--no-icon': !icon,
                'sx-system-message__body--inline': type===3}">
            @if(message){
                <div class="sx-system-message__message" [innerHtml]="message | translate | safeHtml"></div>
            }
            @else {
                <div class="sx-system-message__message">
                    <ng-content></ng-content>
                </div>
            }
        </div>
        <div class="sxl-flex sxl-items-center">
            @if(isDismissable){
                <button *ngIf="isDismissable" class="sx-system-message__close" (click)="onDismissed()">
                    <svg>
                        <use xlink:href="#baseline-close-24px" href="#baseline-close-24px"/>
                    </svg>  
                </button>
            }
        </div>
    </div>  
}
